export const periodTypesEnum = {
	Daily: 'Daily',
	Weekly: 'Weekly',
	FourWeeks: '4 Weeks',
	Monthly: 'Monthly',
	Quarterly: 'Quarterly',
	WholePeriod: 'WholePeriod'
};

export const rosterStatusesEnum = {
	Approved: 'Approved',
	Pending: 'Pending',
	Any: 'Any'
};

export const desiredStateEnum = {
	LowerIsBetter: 'Lower is better',
	HigherIsBetter: 'Higher is better'
};

export const unitOfMeasurementEnum = {
	Percentage: 'Percentage',
	Counter: 'Counter',
	Hours: 'Hours'
};

export const unitStateEnum = {
	VisibleComparable: 'VisibleComparable',
	VisibleNonComparable: 'VisibleNonComparable',
	Hidden: 'Hidden'
};

export const thresholdLogicEnum = {
	Default: 0,
	SingleValue: 1,
	UseLowerValues: 2,
	UseHigherValues: 3,
	Error: -1
};

export const dateRangeGroupEnum = {
	Day: 'Day',
	Week: 'Week',
	Month: 'Month',
	Quarter: 'Quarter',
	Year: 'Year',
	RosterCycle: 'RosterCycle'
};

export const dateRangeNameEnum = {
	Yesterday: 'Yesterday',
	Today: 'Today',
	Tomorrow: 'Tomorrow',
	LastWeek: 'LastWeek',
	CurrentWeek: 'CurrentWeek',
	NextWeek: 'NextWeek',
	LastMonth: 'LastMonth',
	CurrentMonth: 'CurrentMonth',
	NextMonth: 'NextMonth',
	LastQuarter: 'LastQuarter',
	CurrentQuarter: 'CurrentQuarter',
	NextQuarter: 'NextQuarter',
	LastYear: 'LastYear',
	CurrentYear: 'CurrentYear',
	NextYear: 'NextYear',
	LastRosterCycle: 'LastRosterCycle',
	CurrentRosterCycle: 'CurrentRosterCycle',
	NextRosterCycle: 'NextRosterCycle'
};

export const localeCodeEnum = {
	EnglishUnitedKingdom: 'en-gb',
	EnglishUnitedStates: 'en-us',
	EnglishAustralia: 'en-au',
	Danish: 'da',
	German: 'de'
};
